export { type ProductIconProps, default as ProductIcon } from './ProductIcon';
